import { Routes } from "const";
import { memo, lazy } from "react";
import LazyLoad from "components/LazyLoad";
import { Route, Switch } from "react-router-dom";
import InvestorPropertyRoute from "components/permission/routers/InvestorPropertyRoute";
import PwmRoute from "components/permission/routers/PwmRoute";
import AbortOnLeave from "components/AbortOnLeave";

const LzAbt = (Component) => LazyLoad(AbortOnLeave(Component));

const DisclaimerPage = LzAbt(lazy(() => import("./Disclaimer")));
const SuitabilityPage = LzAbt(lazy(() => import("./Register/Suitability")));
const CustomerInfoPage = LzAbt(lazy(() => import("./Register/CustomerInfo")));
const RiskResultPage = LzAbt(lazy(() => import("./Register/RiskResult")));
const TermsConditionsPage = LzAbt(lazy(() => import("./Register/TermsConditions")));
const PrimaryProductListPage = LzAbt(lazy(() => import("./Primary/PrimaryProductList")));
const RegisterPage = LzAbt(lazy(() => import("./UltraHigh/PrivateWealthManagement/RegisterForm")));
const PrimaryProductPage = LzAbt(lazy(() => import("./Primary")));
const PortfolioRoute = LzAbt(lazy(() => import("./UltraHigh/Portfolio")));
const SecondaryMarketRoute = LzAbt(lazy(() => import("./SecondaryMarket")));
const HistoriesRoute = LzAbt(lazy(() => import("./HistoryNew/Histories")));
const SecondaryMySecuritiesDetailSecondaryRoute = LzAbt(lazy(() => import("./SecondaryMarket/MySecuritiesDetail")));
const HistoryTax = LzAbt(lazy(() => import("./SecondaryMarket/HistoryTax")));
const PwmDisclaimerPage = LzAbt(lazy(() => import("./UltraHigh/PrivateWealthManagement/Disclaimer")));
const PwmDisclaimerPage2 = LzAbt(lazy(() => import("./UltraHigh/PrivateWealthManagement/Disclaimer2")));
const BuySellSwitchingRoute = LzAbt(lazy(() => import("./UltraHigh/BuySellSwitching/BuySellSwitchingRoute")));
const ComplexProductPage = LzAbt(lazy(() => import("./ComplexProduct")));
const SecondaryMarketPage = LzAbt(lazy(() => import("./SecondaryMarket")));
const SecondaryMarketBuySellPage = LzAbt(lazy(() => import("./SecondaryMarket/BuySell")));
const InvestmentPage = LzAbt(lazy(() => import("./UltraHigh/Invest")));
const ProfilePage = LzAbt(lazy(() => import("./Register/Profile")));
const FundPage = LzAbt(lazy(() => import("./UltraHigh/Fund")));
const FundDetailPage = LzAbt(lazy(() => import("./UltraHigh/FundDetail")));
const PreviewPdfPage = LzAbt(lazy(() => import("./UltraHigh/PreviewPdf")));
const ResearchListPage = LzAbt(lazy(() => import("./Research/List")));
const KnowledgeAssessmentPage = LzAbt(lazy(() => import("./KnowledgeAssessment")));
const ModelPortfolioPage = LzAbt(lazy(() => import("./UltraHigh/ModelPortfolio")));
const SystemIsNotReadyPage = LzAbt(lazy(() => import("./ErrorPage/SystemIsNotReady")));
const StructureNotePage = LzAbt(lazy(() => import("./StructureNote")));
const PerpetualBondPage = LzAbt(lazy(() => import("./PerpetualBond")));
const LombardLoanPage = LzAbt(lazy(() => import("./LombardLoan")));
const PrimaryPortOverviewPage = LzAbt(lazy(() => import("./Primary/Redesign/PrimaryPortfolio")));
const CustodianPage = LzAbt(lazy(() => import("./Custodian")));

const AppContent = () => {
  return (
    <Switch>
      <Route path={Routes.Disclaimer} component={DisclaimerPage} />
      <Route path={Routes.Register.Suitability} component={SuitabilityPage} />
      <Route path={Routes.Register.CustomerInfo} component={CustomerInfoPage} />
      <Route path={Routes.Register.RiskResult} component={RiskResultPage} />
      <Route path={Routes.Register.TermsConditions} component={TermsConditionsPage} />
      <Route path={Routes.SystemIsNotReady} component={SystemIsNotReadyPage} />
      <InvestorPropertyRoute path={Routes.Primary.Products} component={PrimaryProductListPage} exact />
      <InvestorPropertyRoute path={Routes.Primary.ProductDetail} component={PrimaryProductPage} />
      <InvestorPropertyRoute path={Routes.Primary.PortOverview} component={PrimaryPortOverviewPage} exact />
      <InvestorPropertyRoute path={Routes.UltraHigh.PrivateWealthManagement.RegisterForm} component={RegisterPage} />
      <InvestorPropertyRoute
        path={Routes.UltraHigh.PrivateWealthManagement.RegisterDisclaimer1}
        component={PwmDisclaimerPage}
      />
      <InvestorPropertyRoute
        path={Routes.UltraHigh.PrivateWealthManagement.RegisterDisclaimer2}
        component={PwmDisclaimerPage2}
      />
      <InvestorPropertyRoute path={Routes.Primary.ComplexProductDetail} component={ComplexProductPage} />
      <InvestorPropertyRoute path={Routes.Secondary.Products} component={SecondaryMarketPage} />
      <InvestorPropertyRoute path={Routes.Secondary.ProductDetail} component={SecondaryMarketBuySellPage} />
      <InvestorPropertyRoute path={Routes.Secondary.Products} component={SecondaryMarketRoute} exact />
      <InvestorPropertyRoute
        path={Routes.Secondary.SecuritiesDetail}
        component={SecondaryMySecuritiesDetailSecondaryRoute}
        exact
      />
      <InvestorPropertyRoute path={Routes.History.Histories} component={HistoriesRoute} />
      <InvestorPropertyRoute path={Routes.Secondary.HistoryTax} component={HistoryTax} />
      <InvestorPropertyRoute path={Routes.Profile} component={ProfilePage} />
      <InvestorPropertyRoute path={Routes.UltraHigh.Fund.Home} component={FundPage} exact />
      <InvestorPropertyRoute path={Routes.UltraHigh.Fund.FundDetail} component={FundDetailPage} />
      <InvestorPropertyRoute path={Routes.UltraHigh.ModelPortfolio} component={ModelPortfolioPage} />
      <PwmRoute path={Routes.UltraHigh.BuySellSwitching.Base} component={BuySellSwitchingRoute} />
      <PwmRoute path={Routes.UltraHigh.Portfolio.Home} component={PortfolioRoute} />
      <PwmRoute path={Routes.UltraHigh.Investment} component={InvestmentPage} />
      <Route path={Routes.UltraHigh.Pdf} component={PreviewPdfPage} />
      <InvestorPropertyRoute path={Routes.Research.ResearchList} component={ResearchListPage} />
      <InvestorPropertyRoute path={Routes.KnowledgeAssessment} component={KnowledgeAssessmentPage} />
      <InvestorPropertyRoute path={Routes.StructureNote} component={StructureNotePage} />
      <InvestorPropertyRoute path={Routes.PerpetualBond} component={PerpetualBondPage} />
      <PwmRoute path={Routes.LombardLoan} component={LombardLoanPage} />
      <InvestorPropertyRoute path={Routes.Custodian} component={CustodianPage} />
    </Switch>
  );
};

export default memo(AppContent);
